import { apiClient } from '@devd-client/api';
import { gql } from 'graphql-request';
import { graphQLClient } from '@devd-client/api';
import { getToken, getOrgId } from '@devd-client/devd/auth';
import {
  ContributorDetailsResponse,
  ContributorGraphqlResponse,
  IntegrationDetailsResponse,
  IssueDetailsPageResponse,
  IssueTypePriorityResponse,
  PrDetailsPageResponse,
  SprintListResponse,
} from '../helpers/metric-details.types';
import {
  RepoListResponse,
  TeammenuResponse,
} from '@devd-client/devd/components';

export const getIntegrationDetails = (): Promise<IntegrationDetailsResponse> =>
  apiClient(`/v1/integration/org/${getOrgId()}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });

export const getTeammenu = (): Promise<TeammenuResponse> =>
  apiClient(`/v2/team/${getOrgId()}/lite`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const downloadCSV = (params: any) => {
  return apiClient(`/v1/csv/prTable/org/${getOrgId()}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params),
  });
};

export const getAllRepos = (source: string): Promise<RepoListResponse> =>
  apiClient(
    `/v1/integration/${source}/org/${getOrgId()}/projects/lite?active=true`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );

export const getContributorDetails = (
  email: string
): Promise<ContributorDetailsResponse> =>
  apiClient(`/v1/org/${getOrgId()}/contributor/${email}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });
export const getIssueTypePriorityOptions =
  (): Promise<IssueTypePriorityResponse> =>
    apiClient(`/v1/issue/org/${getOrgId()}/metadata`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
    });

export const IgnorePrOrIssue = (params: any): Promise<any> =>
  apiClient(`/v1/${params.type}/org/${getOrgId()}?id=${params.id}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({}),
  });

export const getContributorGraphql = async (
  startDate: string,
  endDate: string,
  sprintId: string,
  teamId: string
): Promise<ContributorGraphqlResponse> =>
  await graphQLClient.request<ContributorGraphqlResponse>(
    gql`
      query GetContributorDetails(
        $orgId: String!
        $startDate: String!
        $endDate: String!
        $sprintId: String!
        $teamId: String!
      ) {
        ContributorDetails(
          filter: {
            orgId: $orgId
            startDate: $startDate
            endDate: $endDate
            sprintId: $sprintId
            teamId: $teamId
          }
        ) {
          data {
            name
            email
          }
        }
      }
    `,
    {
      orgId: getOrgId(),
      startDate,
      endDate,
      sprintId,
      teamId,
    }
  );

export const getPrDetailsPage = (): Promise<PrDetailsPageResponse> =>
  apiClient(`/v2/account/org/${getOrgId()}/page/PRDetail`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getIssueDetailsPage = (): Promise<IssueDetailsPageResponse> =>
  apiClient(`/v2/account/org/${getOrgId()}/page/IssueDetail`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getSprintList = (teamId?: string): Promise<SprintListResponse> =>
  apiClient(`/v1/org/${getOrgId()}/sprints${teamId ? `?team=${teamId}` : ''}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });
